import { Button } from "@/components/ui/button"
import { ArrowRight } from "lucide-react"
import { Link } from "react-router-dom"
import { useInView } from "@/hooks/use-in-view"
import { Analytics } from "@/lib/analytics"

export function FinalCTA() {
	const { ref, inView } = useInView()

	return (
		<div ref={ref} className={`transition-opacity duration-700 ease-out ${inView ? "opacity-100" : "opacity-0"}`}>
			<section className="py-24 px-4 text-center">
				<div className="max-w-2xl mx-auto">
					<h2 className="text-3xl sm:text-4xl font-extrabold text-sky-950 dark:text-sky-50 tracking-tight leading-tight">
						Start Tracking Your Dividends Today
					</h2>
					<p className="mt-4 text-base sm:text-lg text-sky-900/65 dark:text-sky-300/55">
						No holding limits. No setup fees.
					</p>
					<div className="mt-8">
						<Link
							to="/signup"
							onClick={() =>
								Analytics.capture("CTA Clicked", { cta: "Create Free Account", location: "final_cta" })
							}
						>
							<Button
								size="lg"
								className="font-bold text-base h-12 px-10 rounded-full bg-sky-600 hover:bg-sky-700 text-white dark:bg-sky-500 dark:hover:bg-sky-400 dark:text-sky-950 shadow-[0_10px_40px_-10px_rgba(14,165,233,0.6)] dark:shadow-[0_10px_40px_-10px_rgba(14,165,233,0.3)] transition-all hover:scale-105"
							>
								Create Free Account <ArrowRight className="ml-2 h-5 w-5" />
							</Button>
						</Link>
					</div>
					<p className="mt-4 text-sm text-sky-600/50 dark:text-sky-400/40">
						No holding limits · No setup fees
					</p>
				</div>
			</section>
		</div>
	)
}
